module.exports = __webpack_public_path__ + "static/media/decline-icon.d7ec0178.svg";